import { type OpenApiSchemaCharacteristicMeta } from '#shared/api/schema';
import { showError, showSuccess } from '#shared/lib/toast';
import { editCharacteristic } from '../api';

export async function restoreCharacteristic(characteristic: OpenApiSchemaCharacteristicMeta) {
    try {
        await editCharacteristic({ ...characteristic, status: 'ACTIVE' });
        showSuccess(`Характеристика ${characteristic.title} восстановлена`);
    } catch (error) {
        showError({ label: `Произошла ошибка при восстановлении ${characteristic.title}` }, error);
    }
}
